<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item class="r-1" title="文书详情" name="1">
      <van-cell-group><van-field label="案号" :value="data.caseNo" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="文书标题" :value="data.caseName" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="法院" :value="data.court" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="裁判文书内容" :value="data.contentClear" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="审理程序" :value="data.trialRound" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="发布日期" :value="data.publishDate" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="裁判日期" :value="data.judgeDate" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="判决结果" :value="data.judgeResult" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="被告" :value="data.defendantlist" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="原告" :value="data.prosecutorlist" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="关联企业信息" name="2">
      <div
        class="item coll2 comWrapper card mt-2 mb-2 p-3"
        v-for="(item, index) in data.relatedComList"
        :key="index"
      >
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span></span>
          {{ item[relatedComListCol[0].field] }}
        </div>
        <van-cell-group>
          <template v-for="(col, idx) in relatedComListCol">
            <van-cell
              v-if="idx > 0"
              :key="'col_' + idx"
              :title="col.title"
              :value="item[col.field]"
            />
          </template>
        </van-cell-group>
      </div>
    </van-collapse-item>
    <van-collapse-item title="关联律所信息" name="3">
      <div
        class="item coll2 comWrapper card mt-2 mb-2 p-3"
        v-for="(item, index) in data.relatedLawList"
        :key="index"
      >
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span></span>
          {{ item[relatedLawListCol[0].field] }}
        </div>
        <van-cell-group>
          <template v-for="(col, idx) in relatedLawListCol">
            <van-cell
              v-if="idx > 0"
              :key="'col_' + idx"
              :title="col.title"
              :value="item[col.field]"
            />
          </template>
        </van-cell-group>
      </div>
    </van-collapse-item>
    <van-collapse-item class="r-1" title="判决文书格式化内容" name="4">
      <van-cell-group><van-field label="当事人" :value="data.judgeDocInfo.partyInfo" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="审理经过" :value="data.judgeDocInfo.trialProcedure" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="本院认为" :value="data.judgeDocInfo.courtConsider" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="原告诉求" :value="data.judgeDocInfo.plaintiffRequest" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="被告答辩" :value="data.judgeDocInfo.defendantReply" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="本院查明" :value="data.judgeDocInfo.courtInspect" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="一审原告诉求" :value="data.judgeDocInfo.plaintiffRequestOfFirst" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="一审被告答辩" :value="data.judgeDocInfo.defendantReplyOfFirst" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="一审法院查明" :value="data.judgeDocInfo.courtInspectOfFirst" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="一审法院认为" :value="data.judgeDocInfo.courtConsiderOfFirst" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="上诉人诉求" :value="data.judgeDocInfo.appellantRequest" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="被上诉人答辩" :value="data.judgeDocInfo.appelleeArguing" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="执行经过" :value="data.judgeDocInfo.executeProcess" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="合议庭" :value="data.judgeDocInfo.collegiateBench" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="裁判日期" :value="data.judgeDocInfo.judege_Date" placeholder="无" readonly /></van-cell-group>
      <van-cell-group><van-field label="书记员" :value="data.judgeDocInfo.recorder" placeholder="无" readonly /></van-cell-group>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
import detailMixin from "../mixins/detail-mixin"
export default {
  name: "judgmentDocCheckDetail",
  mixins: [detailMixin],
  data() {
    return {
      activeNames: ["1", "2", "3", "4"],
      relatedComListCol: [
        { title: "序号", field: "sort" },
        // { title: "KeyNo", field: "keyNo" },
        { title: "名称", field: "name"}
      ],
      relatedLawListCol: [
        { title: "序号", field: "sort" },
        // { title: "KeyNo", field: "keyNo" },
        { title: "名称", field: "name"}
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "../style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;

  &::after{
    left: 0;
  }
}

.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>